import type { TourStep } from '../types';

export const marketReportSteps: TourStep[] = [
  {
    target: '[data-tour="tool-market-report"]',
    title: 'Market Data Report',
    content:
      'This tool generates a comprehensive market conditions analysis for any NJ property — great for CMA supplements, market snapshots, or USPAP-compliant market condition addenda.',
    placement: 'bottom',
    route: '/appraisals/tools',
    nextButtonText: 'Open it',
  },
  {
    target: '[data-tour="market-header"]',
    title: 'Market Report Generator',
    content:
      'The report pulls live data from county tax records, recent sales, economic indicators, demographics, and environmental screening — all in one document.',
    placement: 'bottom',
    route: '/appraisals/tools/market-report',
  },
  {
    target: '[data-tour="market-search"]',
    title: 'Search for a Property',
    content:
      'Type a New Jersey property address and select from the autocomplete results. The system looks up tax records and kicks off data collection automatically. Try searching for a property you know.',
    placement: 'bottom',
    route: '/appraisals/tools/market-report',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve searched',
  },
  {
    target: '[data-tour="market-report"]',
    title: 'Your Generated Report',
    content:
      'The full report renders here with market trends, comparable sales, neighborhood statistics, and environmental data. Use Ctrl+P to print it directly, or scroll through to review each section.',
    placement: 'top',
    route: '/appraisals/tools/market-report',
  },
];
